import { parseDefiniteQuotationDTO, QuotationDTO } from 'components/ordering/quotation/api/dtos/quotation-dto.js'
import { StatusCodeToError } from 'components/ordering/quotation/api/dtos/error.js'
import { QuotationRequest } from 'components/ordering/quotation/api/quotation-request.js'


const EXPECTED_ERRORS = [400, 404] as const
type ExpectedErrors = StatusCodeToError<typeof EXPECTED_ERRORS[number]>

type SetDraftQuotationPayload = {
  quotationId: number
}


export class SetDraftQuotation extends QuotationRequest<QuotationDTO, ExpectedErrors> {
  path: string
  override init: RequestInit
  override expectedErrors = EXPECTED_ERRORS

  constructor({ quotationId }: SetDraftQuotationPayload) {
    super()

    this.path = `quotation/${quotationId}/set_draft/`
    this.init = {
      method: 'POST',
    }
  }

  override parseResponse = parseDefiniteQuotationDTO
}
